// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"a26c5dab","228":"5e72fa9e","276":"e1dd3711","456":"f10f6b6e","540":"47083374","572":"fd53a874","600":"c8c5fe46","604":"98728bfb","772":"483de4c4","824":"6a32af67","900":"dc094b1d","904":"635c7ff0","936":"284c5291","956":"7efd9741"}[chunkId] + ".chunk.js";
};